import React, { Component } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { withStyles } from '@mui/styles';
import AssignmentDetailCard from '../AssignmentDetailCard/AssignmentDetailCard';
import AssignmentDocumentComponentV2 from '../AssignmentDocumentComponent/AssignmentDocumentComponentV2';
import { FeatureFlag } from '../../GlobalComponents/FeatureFlagComponent/FeatureFlag';
import TravelV2 from '../Travel/TravelV2';
import TravelV3 from '../Travel/TravelV3';

const styles = (theme) => ({});

class PastAssignmentDetailView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
        };
    }

    render() {
        const { assignment, externalId } = this.props;
        const { activeTab } = this.state;

        if (!assignment) {
            return <p>Error, Assignment not found</p>;
        }

        return (
            <>
                <AssignmentDetailCard assignment={assignment} type="past" />

                <Box sx={{ width: '100%', mt: 3 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => this.setState({ activeTab: newValue })}
                        aria-label="Assignment Tabs"
                    >
                        <Tab label="Travel" />
                        <Tab label="Documents" />
                    </Tabs>

                    <Box>
                        {activeTab === 0 && (
                            <>
                                <FeatureFlag
                                    name="TravelV3"
                                    isFlagEnabled="false"
                                    fallbackValue={false}
                                >
                                    <TravelV2
                                        assignment={assignment}
                                        externalId={externalId}
                                        filter="active"
                                    />
                                </FeatureFlag>

                                <FeatureFlag
                                    name="TravelV3"
                                    isFlagEnabled="true"
                                    fallbackValue={false}
                                >
                                    <TravelV3
                                        assignment={assignment}
                                        externalId={externalId}
                                        filter="active"
                                    />
                                </FeatureFlag>
                            </>
                        )}

                        {activeTab === 1 && (
                            <AssignmentDocumentComponentV2 assignmentName={assignment.name} />
                        )}
                    </Box>
                </Box>
            </>
        );
    }
}

export default withStyles(styles)(PastAssignmentDetailView);
